// extracted by mini-css-extract-plugin
module.exports = {"main":"ArchetypeDescriptions_main__dusFk","header":"ArchetypeDescriptions_header__VC2l6","desc":"ArchetypeDescriptions_desc__nSwS6"};